import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The warehouse root has no screen of its own - it redirects to Tasks.
 *
 * A `beforeLoad` redirect rather than a component that navigates on mount: this
 * URL is reached by trimming a deeper one (the warehouse selector does exactly
 * that), and a mount-then-navigate would flash an empty content column first.
 *
 * The Outbound Dashboard is what the design leads with, so it is where a
 * manager's day starts.
 */
export const Route = createFileRoute(
  "/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$lang/orgs/$org/outbound/whs/$location/dashboard",
      params,
      replace: true,
    });
  },
});
